<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-sm-12 col-md-3 d-flex align-items-start flex-column justify-content-center"
        >
          <h1 [ngClass]="" id="serialNumber"></h1>
          <span class="status"> </span>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="element"
            class="no-subscript"
          >
            <mat-label>Operator initiating form</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="element.createdByName"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="element"
            class="no-subscript"
          >
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(element.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end"
        >
          <div class="d-flex small d-print-none" *ngIf="element?.editingBy">
            Modifying by:&nbsp;<b class="yellow">{{
              element?.editingBy?.name
            }}</b>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <!-- <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          > -->
          <!-- <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box> -->
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <!-- <template-side></template-side> -->
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons"> </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content" [ngClass]="{}">
          <olog-main></olog-main>
          <!-- Main Content Here -->
        </div>
        <div
          class="buttons d-print-none"
          id="sidenav-content-buttons"
          [ngClass]="{}"
        ></div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
